import type { EventSourceContext } from './clickStreamEvent';
import {
  EventSources,
  makeEventName,
  recordMoMetricsEvent,
  recordMoMetricsEventImmediately
} from './moMetrics';

enum EventActions {
  Clicked = 'clicked',
  Rendered = 'component_rendered'
}

type EventType = 'Clicked' | 'Rendered';

enum EventNames {
  Clicked = 'Clicked',
  Rendered = 'Rendered'
}

const makeEvent = (
  eventName: string,
  details: Partial<EventSourceContext>
): EventSourceContext => ({
  eventName: makeEventName(eventName),
  eventTime: new Date(),
  ...details
});

const uiAttributes = (additionalEventData: any = null) => ({
  ...additionalEventData
});

const createEvent = (
  component: string,
  pageName: string,
  eventType: EventType
): EventSourceContext => {
  const eventName = component ? `${pageName}:${component}` : pageName;
  return makeEvent(`${eventName} - ${EventNames[eventType]}`, {
    eventAction: EventActions[eventType],
    eventSourceName: component ? `Component:${component}` : `Page:${pageName}`,
    eventSource: EventSources.UserInteraction
  });
};

const recordAction = (
  pageName: string,
  component: string,
  eventType: EventType,
  eventData?: Record<string, unknown>
) => {
  const event = createEvent(component, pageName, eventType);
  recordMoMetricsEvent(event, uiAttributes(eventData));
};

const recordActionImmediately = (
  pageName: string,
  component: string,
  eventType: EventType,
  eventData?: Record<string, unknown>
) => {
  const event = createEvent(component, pageName, eventType);

  return recordMoMetricsEventImmediately(event, uiAttributes(eventData));
};

const recordError = (error: string, errorInfo: string) => _ => {
  recordMoMetricsEvent(
    makeEvent('Error', {
      eventSourceName: 'JavascriptError'
    }),
    uiAttributes({ error, errorInfo })
  );
};

export { recordError, recordAction, recordActionImmediately };
